// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sitemap-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.sitemap-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.sitemap-header {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  font-family: "Poppins", sans-serif;
}

.btn-container {
  display: flex;
  gap: 10px;
}

.bordered-button {
  text-transform: none !important;
  font-family: "Poppins", sans-serif !important;
}

.sitemap-table-container {
  margin-top: 20px;
  border-radius: 8px !important;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.table-header {
  font-weight: 600 !important;
  background-color: #f8f9fa;
  font-family: "Poppins", sans-serif !important;
  font-size: 14px !important;
}

.sitemap-name {
  font-family: monospace;
  font-weight: 500;
  color: #1976d2;
}

.action-button {
  margin: 0 4px !important;
}

.action-button:hover {
  transform: scale(1.1);
  transition: transform 0.2s;
}

.no-data {
  padding: 40px !important;
  color: #999;
  font-family: "Poppins", sans-serif;
}

.upload-dialog-content {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-button {
  margin-top: 10px !important;
  text-transform: none !important;
  font-family: "Poppins", sans-serif !important;
}

.selected-file {
  margin-top: 10px;
  padding: 10px;
  background-color: #e3f2fd;
  border-radius: 4px;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
}

.edit-dialog-content {
  margin-top: 20px;
}

.xml-editor textarea {
  font-family: "Courier New", monospace !important;
  font-size: 12px !important;
  line-height: 1.5 !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .sitemap-header-container {
    flex-direction: column;
    gap: 15px;
  }

  .sitemap-header {
    font-size: 20px;
  }

  .btn-container {
    width: 100%;
  }

  .btn-container button {
    width: 100%;
  }

  .sitemap-table-container {
    overflow-x: auto;
  }

  .table-header,
  .sitemap-name,
  .action-button {
    font-size: 12px !important;
  }
}

/* Scrollbar styling for XML editor */
.xml-editor textarea::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.xml-editor textarea::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.xml-editor textarea::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.xml-editor textarea::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.sitemap-loc {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: monospace;
  font-size: 12px;
}

.sitemap-loc a {
  color: #1976d2;
  text-decoration: none;
}

.sitemap-loc a:hover {
  text-decoration: underline;
}

.xml-hint {
  margin-top: 8px;
  padding: 8px;
  background-color: #fff3e0;
  border-radius: 4px;
  color: #e65100;
  font-size: 12px;
}

.xml-viewer textarea {
  font-family: "Courier New", monospace !important;
  font-size: 12px !important;
  background-color: #f5f5f5;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

/* Button styles */
.bordered-button {
  text-transform: none !important;
  font-family: "Poppins", sans-serif !important;
  background-color: #1976d2 !important;
}

.bordered-button:hover {
  background-color: #1565c0 !important;
}

/* Responsive styles */
@media (max-width: 768px) {
  .sitemap-loc {
    max-width: 150px;
  }

  .sitemap-name {
    font-size: 12px;
  }
}
/* Add to sitemap.css */
.changefreq-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}

.changefreq-badge.always {
  background-color: #e3f2fd;
  color: #1976d2;
}

.changefreq-badge.hourly {
  background-color: #e8f5e9;
  color: #388e3c;
}

.changefreq-badge.daily {
  background-color: #fff3e0;
  color: #f57c00;
}

.changefreq-badge.weekly {
  background-color: #f3e5f5;
  color: #7b1fa2;
}

.changefreq-badge.monthly {
  background-color: #fce4ec;
  color: #c2185b;
}

.changefreq-badge.yearly {
  background-color: #e0f2f1;
  color: #00796b;
}

.sitemap-loc {
  max-width: 400px;
  word-break: break-all;
  font-family: monospace;
  font-size: 12px;
}

.sitemap-loc a {
  color: #1976d2;
  text-decoration: none;
}

.sitemap-loc a:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/features/Sitemap/sitemap.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA,qCAAqC;AACrC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;AACA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".sitemap-container {\n  padding: 20px;\n  background-color: #f5f5f5;\n  min-height: 100vh;\n}\n\n.sitemap-header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding: 20px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.sitemap-header {\n  font-size: 24px;\n  font-weight: 600;\n  color: #333;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.btn-container {\n  display: flex;\n  gap: 10px;\n}\n\n.bordered-button {\n  text-transform: none !important;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.sitemap-table-container {\n  margin-top: 20px;\n  border-radius: 8px !important;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;\n}\n\n.table-header {\n  font-weight: 600 !important;\n  background-color: #f8f9fa;\n  font-family: \"Poppins\", sans-serif !important;\n  font-size: 14px !important;\n}\n\n.sitemap-name {\n  font-family: monospace;\n  font-weight: 500;\n  color: #1976d2;\n}\n\n.action-button {\n  margin: 0 4px !important;\n}\n\n.action-button:hover {\n  transform: scale(1.1);\n  transition: transform 0.2s;\n}\n\n.no-data {\n  padding: 40px !important;\n  color: #999;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.upload-dialog-content {\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.upload-button {\n  margin-top: 10px !important;\n  text-transform: none !important;\n  font-family: \"Poppins\", sans-serif !important;\n}\n\n.selected-file {\n  margin-top: 10px;\n  padding: 10px;\n  background-color: #e3f2fd;\n  border-radius: 4px;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 14px;\n}\n\n.edit-dialog-content {\n  margin-top: 20px;\n}\n\n.xml-editor textarea {\n  font-family: \"Courier New\", monospace !important;\n  font-size: 12px !important;\n  line-height: 1.5 !important;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .sitemap-header-container {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .sitemap-header {\n    font-size: 20px;\n  }\n\n  .btn-container {\n    width: 100%;\n  }\n\n  .btn-container button {\n    width: 100%;\n  }\n\n  .sitemap-table-container {\n    overflow-x: auto;\n  }\n\n  .table-header,\n  .sitemap-name,\n  .action-button {\n    font-size: 12px !important;\n  }\n}\n\n/* Scrollbar styling for XML editor */\n.xml-editor textarea::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.xml-editor textarea::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.xml-editor textarea::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.xml-editor textarea::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.sitemap-loc {\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: monospace;\n  font-size: 12px;\n}\n\n.sitemap-loc a {\n  color: #1976d2;\n  text-decoration: none;\n}\n\n.sitemap-loc a:hover {\n  text-decoration: underline;\n}\n\n.xml-hint {\n  margin-top: 8px;\n  padding: 8px;\n  background-color: #fff3e0;\n  border-radius: 4px;\n  color: #e65100;\n  font-size: 12px;\n}\n\n.xml-viewer textarea {\n  font-family: \"Courier New\", monospace !important;\n  font-size: 12px !important;\n  background-color: #f5f5f5;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px;\n}\n\n/* Button styles */\n.bordered-button {\n  text-transform: none !important;\n  font-family: \"Poppins\", sans-serif !important;\n  background-color: #1976d2 !important;\n}\n\n.bordered-button:hover {\n  background-color: #1565c0 !important;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .sitemap-loc {\n    max-width: 150px;\n  }\n\n  .sitemap-name {\n    font-size: 12px;\n  }\n}\n/* Add to sitemap.css */\n.changefreq-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.changefreq-badge.always {\n  background-color: #e3f2fd;\n  color: #1976d2;\n}\n\n.changefreq-badge.hourly {\n  background-color: #e8f5e9;\n  color: #388e3c;\n}\n\n.changefreq-badge.daily {\n  background-color: #fff3e0;\n  color: #f57c00;\n}\n\n.changefreq-badge.weekly {\n  background-color: #f3e5f5;\n  color: #7b1fa2;\n}\n\n.changefreq-badge.monthly {\n  background-color: #fce4ec;\n  color: #c2185b;\n}\n\n.changefreq-badge.yearly {\n  background-color: #e0f2f1;\n  color: #00796b;\n}\n\n.sitemap-loc {\n  max-width: 400px;\n  word-break: break-all;\n  font-family: monospace;\n  font-size: 12px;\n}\n\n.sitemap-loc a {\n  color: #1976d2;\n  text-decoration: none;\n}\n\n.sitemap-loc a:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
